import { Alert } from 'antd';
import { useSyncExternalStore } from 'react';
import { useIntl } from 'react-intl';

function subscribeOnlineStatus(callback: () => void) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);

  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

function getOnlineStatus() {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}

export default function OfflineBanner() {
  const intl = useIntl();
  const isOnline = useSyncExternalStore(
    subscribeOnlineStatus,
    getOnlineStatus,
    () => true,
  );

  if (isOnline) return null;

  return (
    <Alert
      type="warning"
      showIcon
      closable={false}
      style={{
        position: 'fixed',
        top: 8,
        left: '50%',
        zIndex: 10,
        maxWidth: 480,
        transform: 'translateX(-50%)',
      }}
      title={intl.formatMessage({
        id: 'app.network.offline',
        defaultMessage: 'You are currently offline. Some features may be unavailable.',
      })}
    />
  );
}
